/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc9Inputs */

const en_fc_tut_sc9 = /** @type {(inputs: Fc_Tut_Sc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nudge edit point (⇧ for ×5)`)
};

/**
* | output |
* | --- |
* | "Nudge edit point (⇧ for ×5)" |
*
* @param {Fc_Tut_Sc9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc9 = /** @type {((inputs?: Fc_Tut_Sc9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc9(inputs)
});
export { fc_tut_sc9 as "fc.tut.sc9" }